export const PROD_URL = "https://bela-jakarta.piawaindonesia.id";
export const DEV_URL = "http://localhost:8000";
